module.exports = __webpack_public_path__ + "img/img_text_1.f86c528f.png";